@if (!!underWritingQuestionsForm) {
  <div class="risk-list">
    <div [formGroup]="underWritingQuestionsForm" class="row risk">
      <div class="self-center pad-10">
        <div class="self-center">
          <div class="risk-info">
            <div>{{ questionObject.question }}</div>
          </div>
        </div>
        <fieldset class="radio">
          <div class="self-center pad-right-30">
            <input
              type="radio"
              [formControlName]="'question' + questionObject.id"
              [value]="'yes'"
              [attr.id]="'selected-yes' + questionObject.id"
              (click)="answerClick(true)"
            />
            <label
              [attr.for]="'selected-yes' + questionObject.id"
              class="checkbox-label"
              data-cy="replaceVehicleUnderwritingQuestionYesRadio"
              >Yes</label
            >
          </div>
          <div class="self-center pad-right-30">
            <input
              type="radio"
              [formControlName]="'question' + questionObject.id"
              [value]="'no'"
              [attr.id]="'selected-no' + questionObject.id"
              (click)="answerClick(false)"
              data-cy="replaceVehicleUnderwritingQuestionNoRadio"
            />
            <label [attr.for]="'selected-no' + questionObject.id" class="checkbox-label">No</label>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
}
